import { isCaseWorkspaceOperationsApi } from "./mehrsanOperationsConstants";

export { isCaseWorkspaceOperationsApi };

export const shouldShowFinancialTab = isCaseWorkspaceOperationsApi;

/** FinancialStatus — هم‌تراز API */
export const FINANCIAL_STATUSES = [
  { value: 0, label: "پیش‌نویس" },
  { value: 1, label: "در انتظار پرداخت" },
  { value: 2, label: "پرداخت جزئی" },
  { value: 3, label: "تسویه شده" },
  { value: 4, label: "سررسید گذشته" },
  { value: 5, label: "لغو شده" },
];

/** SlnInvoiceStatus */
export const SLN_INVOICE_STATUSES = [
  { value: 0, label: "پیش‌نویس" },
  { value: 1, label: "صادر شده" },
  { value: 2, label: "پرداخت جزئی" },
  { value: 3, label: "پرداخت شده" },
  { value: 4, label: "لغو شده" },
  { value: 5, label: "در انتظار پرداخت" },
];

/** SlnPaymentMethod */
export const PAYMENT_METHODS = [
  { value: 1, label: "درگاه آنلاین" },
  { value: 2, label: "کارت به کارت / واریز دستی" },
  { value: 3, label: "پرداخت وام" },
  { value: 4, label: "پرداخت قدیمی (ProjectPayment)" },
  { value: 5, label: "نقدی" },
  { value: 6, label: "اعتبار پنل" },
  { value: 99, label: "سایر" },
];

export const PAYMENT_METHOD_LEGACY = 4;
export const PAYMENT_METHOD_LOAN = 3;
export const PAYMENT_METHOD_ONLINE = 1;

/** PaymentTransactionStatus */
export const TRANSACTION_STATUSES = [
  { value: 0, label: "در انتظار" },
  { value: 1, label: "در انتظار تایید" },
  { value: 2, label: "موفق" },
  { value: 3, label: "ناموفق" },
  { value: 4, label: "لغو شده" },
  { value: 5, label: "رد شده" },
];

export const STATUS_WAITING_APPROVAL = 1;
export const STATUS_SUCCEEDED = 2;
export const STATUS_REJECTED = 5;

export const getFinancialStatusChipColor = (status) => {
  const s = Number(status);
  if (s === 3) return "success";
  if (s === 2 || s === 1) return "warning";
  if (s === 4) return "error";
  if (s === 5) return "error";
  return "default";
};

export const getInvoiceStatusChipColor = (status) => {
  const s = Number(status);
  if (s === 3) return "success";
  if (s === 2 || s === 5) return "warning";
  if (s === 4) return "error";
  return "default";
};

export const getTransactionStatusChipColor = (status) => {
  const s = Number(status);
  if (s === 2) return "success";
  if (s === 1) return "warning";
  if (s === 3 || s === 5) return "error";
  return "default";
};
